import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-california-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./california-state-form.component.html",
  styleUrl: "./california-state-form.component.scss",
})
export class CaliforniaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
